import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './shared/services/auth/auth.guard';
import { PaiementComponent } from './views/paiement/paiement.component';

export const rootRouterConfig: Routes = [
  {
    path: '',
    redirectTo: 'kyrmann',
    pathMatch: 'full',
  },
  /*{
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'sessions',
        loadChildren: './views/sessions/sessions.module#SessionsModule',
        data: { title: 'Session'}
      }
    ]
  },*/
  // {
  //   path: '',
  //     component: PaiementComponent,
  //   },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './views/paiement/paiement.module#PaiementModule',
        data: { title: 'Paiement', breadcrumb: 'PAIEMENT'}
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'sessions/404'
  }
];

